// extracted by mini-css-extract-plugin
module.exports = {"root":"CreatorCollectionsLink_root__nvoJM","report-event-wrapper":"CreatorCollectionsLink_report-event-wrapper__iosl_"};